import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const types = [{
  id: 'manchados',
  label: 'Manchados',
  image: 'https://cdn.magicpatterns.com/uploads/1XYSyeb8AQmKCNXXbdVp8T/DC7QKWDZ5ZC3FM7KWRRKBAHOZU.jpg'
}, {
  id: 'rotos',
  label: 'Rotos',
  image: 'https://cdn.magicpatterns.com/uploads/gPLGXgFbe3RRtQxQY8emR9/7e22148ecf8b3e929f49a3a0b2725d3e.jpg'
}, {
  id: 'escritos',
  label: 'Escritos',
  image: 'https://cdn.magicpatterns.com/uploads/qqchSEjkRWzB8wmfxR4bzU/hay-escondites-realmente-seguros-y___-NKVMwOIr_720x0__1.jpg'
}, {
  id: 'quemados',
  label: 'Quemados',
  image: 'https://cdn.magicpatterns.com/uploads/dUWMXFEqZRC3yCgP1tnWfM/MW52DQOYSVFLXK5IW3QMKGRZJU.jpg'
}];
export function Gallery() {
  return <section className="py-24 bg-white border-t border-slate-200" data-id="element-49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="text-center mb-16" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0a2540] mb-4" data-id="element-52">
            Compramos billetes como estos
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-53">
            No importa el nivel de daño, evaluamos cada caso de forma
            particular.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-54">
          {types.map((type, index) => <motion.div key={type.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group relative aspect-[4/3] rounded-2xl overflow-hidden bg-slate-100 border border-slate-200 shadow-sm hover:shadow-md transition-all duration-300" data-id="element-55">
              <img src={type.image} alt={`Billetes ${type.label.toLowerCase()}`} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" data-id="element-56" />

              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent" data-id="element-57"></div>

              <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-58">
                <h3 className="text-xl font-semibold text-white text-center group-hover:text-blue-200 transition-colors duration-300 drop-shadow-md" data-id="element-59">
                  {type.label}
                </h3>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}